var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenOut = function SvgOpenOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3A8EF6",
    d: "M5.846 20h11.077a1.85 1.85 0 0 0 1.846-1.846V13.23a.615.615 0 1 0-1.23 0v4.923c0 .34-.277.615-.616.615H5.846a.616.616 0 0 1-.615-.615V7.077c0-.34.276-.615.615-.615h4.923a.615.615 0 1 0 0-1.231H5.846A1.85 1.85 0 0 0 4 7.077v11.077C4 19.172 4.828 20 5.846 20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A8EF6",
    d: "M14.461 4a.615.615 0 1 0 0 1.23H17.9l-5.103 5.104a.615.615 0 1 0 .87.87l5.103-5.103v3.437a.615.615 0 1 0 1.23 0V4z"
  })));
};
export default SvgOpenOut;